import React, {useState} from "react";
import dayjs from "dayjs";
import Big from "big.js";
import {useOutletContext} from "react-router-dom";
import {useCurrentUser} from "../../utils/CurrentUserContext";
import ReportNewTime from "./ReportNewTime";
import ReportNew from "./ReportNew";


const Report = () => {
  const {campaign} = useOutletContext();


  // Day when we introduced new readtime methodology
  const comparisonDate = dayjs("2024-09-16T00:00:00.090Z");
  const campStartData = dayjs(campaign.startDate)

  // Check if the campaign start date is after the comparison date
  const startDate = dayjs(campStartData).isAfter(comparisonDate);

  if (startDate) {
    return (
      <ReportNewTime />
    )
  }

  return (
    <ReportNew />
  )

}

export default Report;
